import { Brain } from 'lucide-react';
import { ClinicalInsightData } from '../../../../../types/live-insights';

interface CoreBeliefCardProps {
    data: ClinicalInsightData;
}

export function CoreBeliefCard({ data }: CoreBeliefCardProps) {
    return (
        <div className="group relative overflow-hidden rounded-xl bg-white/40 p-4 shadow-sm ring-1 ring-black/5 backdrop-blur-md transition-all hover:shadow-md hover:ring-black/10">
            {/* Soft purple accent */}
            <div className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-purple-400/60 to-indigo-500/60" />

            <div className="flex items-start gap-3">
                <div className="mt-1 rounded-full bg-purple-50 p-1.5 text-purple-600">
                    <Brain className="h-4 w-4" />
                </div>
                <div className="flex-1 space-y-1">
                    <div className="flex items-center justify-between">
                        <h4 className="text-sm font-semibold text-slate-800 tracking-tight">
                            {data.title}
                        </h4>
                    </div>
                    <p className="text-xs leading-relaxed text-slate-600">
                        {data.content}
                    </p>
                </div>
            </div>
        </div>
    );
}
